module.exports = __webpack_public_path__ + "static/media/appStore.1cffad87.svg";